export default [
  // {
  //   statusName: 'Total',
  //   status: 'Total Orders',
  //   bgColor: '#fbe9f8',
  //   totalCount: 0,
  //   statusId: [],
  //   darkColor: '#f0b0e4',
  //   showInEmployees: true,
  //   showForHR : true,
  // },
  {
    statusName: 'Cancelled',
    status: 'Cancelled Orders',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22],
    darkColor: '#d7f2f3',
    showForHR : false,
  },
  { // Delivered
    statusName: 'Delivered',
    status: 'Delivered Orders',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22],
    darkColor: '#cde3fd',
    showForHR : true,
  },
  {
    statusName: 'OrderPlaced',
    status: 'New Orders',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22, 29, 30, 31],
    darkColor: '#40d9c4',
    showInEmployees: true,
    showForHR : false,
  },
  {
    statusName: 'Confirmed',
    status: 'Confirmed orders',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22, 29, 30, 31],
    darkColor: '#b6e5b9',
    showInEmployees: true,
    showForHR : false,
  },
  {
    statusName: 'OrderAccepted',
    status: 'Orders Accepted',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22, 29, 30, 31],
    darkColor: '#e5e5e5',
    showInEmployees: true,
    showForHR : false,
  },
  {
    statusName: 'OrderinProgress',
    status: 'Orders in Progress',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22, 29, 30, 31],
    darkColor: '#bb6258',
    showInEmployees: true,
    showForHR : false,
  },
  {
    statusName: 'OutforDeliver',
    status: 'Out for Deliver',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22, 29, 30, 31],
    darkColor: '#c0c0c0',
    showInEmployees: true,
    showForHR : false,
  }
];
